const PromoDeal = {
    EXPRESS_DEAL: 'EXPRESS_DEAL',
    NHA: 'NHA'
};
const GEO = 'GEO';
const HOTEL_DEFAULT_VALUES = {
    endLocation: null,
    startLocation: null,
    startDate: '',
    endDate: '',
    tripType: 'STAY',
    mapView: false
};
const HOTEL_LABELS = {
    endLocation: 'Where to?',
    startLocation: 'Where from?',
    datePicker: 'Check-in - Check-out'
};
export { GEO, HOTEL_DEFAULT_VALUES, HOTEL_LABELS, PromoDeal };
